<template>
  <b-card>
    <b-tabs
      vertical
      content-class="col-12 col-md-10 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-2 col-12"
      nav-class="nav-left"
    >
      <b-tab
        active
        title="Kardex"
      >
        <app-timeline
          v-if="maestrias.length"
          class="mt-2"
        >
          <transition-group
            name="especialidades"
            tag="ul"
          >
            <kardex
              v-for="espe in maestrias"
              :key="espe.id_espe"
              style="list-style: none"
              :especialidad="espe"
            />
          </transition-group>
        </app-timeline>
        <b-alert
          v-else
          variant="primary"
          show
        >
          <h4 class="alert-heading">
            <feather-icon
              class="mr-25"
              icon="StarIcon"
            /><span
              class="ml-25"
            >Hola, aun no cuentas con ninguna especialidad vigente.</span>
          </h4>
          <div class="alert-body">
            <span>Te invitamos a que visites las especialidades que tenemos
              preparadas para ti.</span>
            <b-badge
              class="ml-2"
              href="/oferta-academica"
              variant="light-warning"
            >
              <feather-icon
                icon="LinkIcon"
                class="mr-25"
              />
              <span>Visitar</span>
            </b-badge>
          </div>
        </b-alert>
      </b-tab>
      <b-tab
        title="Becas Obtenidas"
        lazy
      >
        <becas-obtenidas />
      </b-tab>
      <b-tab title="Completado">
        <b-alert
          variant="primary"
          show
        >
          <h4 class="alert-heading">
            <feather-icon
              class="mr-25"
              icon="StarIcon"
            /><span
              class="ml-25"
            >Hola, aun no cuentas con ninguna especialidad terminada.</span>
          </h4>
          <div class="alert-body">
            <span>Te invitamos a que visites las especialidades que tenemos
              preparadas para ti.</span>
            <router-link
              :to="{ name: 'oferta-academica'}"
            >
              <b-badge
                class="ml-2"
                variant="light-warning"
              >
                <feather-icon
                  icon="LinkIcon"
                  class="mr-25"
                />
                <span>Visitar</span>
              </b-badge>
            </router-link>
          </div>
        </b-alert>
      </b-tab>
      <b-tab title="Salon de Clases">
        <b-row class="col-12">
          <b-col
            lg="2"
            md="12"
          />
          <b-col
            lg="8"
            md="12"
          >
            <salon-modle />
          </b-col>
          <b-col
            lg="2"
            md="12"
          />
        </b-row>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import {
  BCol,
  BRow,
  BCard,
  BTabs,
  BTab,
  VBToggle,
  VBTooltip,
  BAlert,
  BBadge,
} from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import kardex from '@/views/campus/alumno/components/kardex/kardex.vue'
import SalonModle from '@/views/campus/alumno/components/kardex/SalonModle.vue'
// import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import BecasObtenidas from './components/kardex/BecasObtenidas.vue'
import { getEspecialidades } from './useAlumno'

export default {
  components: {
    BCol,
    BRow,
    BCard,
    SalonModle,
    BTabs,
    BTab,
    // BOverlay,
    AppTimeline,
    kardex,
    BAlert,
    BBadge,
    BecasObtenidas,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },

  setup() {
    const toast = useToast()
    const maestrias = ref({})
    // const loadmae = ref({ flag: false })
    // loadmae.value.flag = false

    const loadkardex = () => {
      // loadmae.value.flag = true
      getEspecialidades().then(
        response => {
          maestrias.value = response.result
          toast({
            component: ToastificationContent,
            props: {
              title: 'Buscando..',
              text: response.msn,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          // loadmae.value.flag = false
        },
        error => {
          toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: error,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 10000 },
          )
        },
      )
    }
    onMounted(() => {
      loadkardex()
    })
    return {
      maestrias,
      // loadmae,
    }
  },
}
</script>
